import { SWReactIcons } from "@similarweb/icons";
import { TextAnchorCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { ItemIcon, Type } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_OVERVIEW } from "app/pages/sales-intelligence/constants/routes";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";
import type { CompanyAnalysisCompetititorItem } from "app/pages/sales-intelligence/modules/company-analysis/types/competitors";
import AddWebsiteToListButtonContainer from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/AddToListButton/AddWebsiteToListButtonContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const CompetitorsTableRow = ({
    item,
    withoutTopBorder,
}: {
    item: CompanyAnalysisCompetititorItem;
    withoutTopBorder?: boolean;
}) => {
    const { domain, favicon, name, signalsCount = 0 } = item;
    const companyName = useCompanyName();

    const handleCompetitorClick = () => {
        companyAnalysisTrackingService.widgets.trackCompetitorsDomainClick(companyName, domain);
    };

    const handleAddToListClick = () => {
        companyAnalysisTrackingService.widgets.trackAddCompetitorToList(companyName, domain);
    };

    return (
        <Flex
            minHeight="62px"
            width="100%"
            alignItems="center"
            padding="15px 0px 15px 8px"
            gap="8px"
            justifyContent="space-between"
            borderTop={withoutTopBorder ? "none" : `1px solid ${colorsPalettes.carbon[50]}`}
        >
            <div onMouseDown={handleCompetitorClick}>
                <TextAnchorCell
                    href={proNavigator.href(COMPANY_ANALYSIS_OVERVIEW, {
                        key: domain,
                    })}
                >
                    <Flex
                        alignItems="center"
                        gap="8px"
                    >
                        <ItemIcon
                            iconType={Type.Website}
                            iconSrc={favicon || ""}
                        />
                        {name || domain}
                    </Flex>
                </TextAnchorCell>
            </div>
            <Flex
                alignItems="center"
                gap="4px"
            >
                <SWReactIcons
                    iconName="alerts"
                    size="sm"
                />
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.carbon[300]}
                    padding="0 16px 0 0"
                    minWidth="88px"
                >
                    {`${signalsCount} ${translate("si.company-analysis.competitors.signals-count")}`}
                </Text>
                <Box
                    background={colorsPalettes.carbon[100]}
                    width="1px"
                    height="16px"
                />
                <AddWebsiteToListButtonContainer
                    domain={domain}
                    onClick={handleAddToListClick}
                />
            </Flex>
        </Flex>
    );
};

export default CompetitorsTableRow;
